import { render } from "./ContentsList.vue?vue&type=template&id=8e1c6182"
import script from "./ContentsList.vue?vue&type=script&lang=js"
export * from "./ContentsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__